import { Component, OnInit, Input, Output, EventEmitter, OnChanges, OnDestroy } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { delay, filter, map, switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { LgvUserService } from '../../core/services/lgv-user.service';
import { LgvModel } from '../../data-models/longevity.model';

@Component({
    selector: 'lgv-user-search',
    templateUrl: './user-search.component.html',
    styleUrls: ['./user-search.component.scss']
})

export class UserSearchComponent implements OnInit, OnChanges, OnDestroy {

    //@Input() CSSClass: string = '';
    @Output() OnUserSelectionMade = new EventEmitter<LgvModel.UserDTO>();

    @Input() PreSelectedUser: LgvModel.UserDTO;
    @Input() SearchState: string;
    @Input() UserType: string;
    @Input() ShowLabelAbove: boolean = true;
    @Input() ShowLabelFloating: boolean = false;
    @Input() Label: string;
    @Input() FilterMode: string;
    @Input() UserId: string;
    @Input() IsRequired: boolean = false;

    UserSearchForm: UntypedFormGroup;
    SelectedUser: LgvModel.UserDTO;
    ShowSearch: boolean = true;


    _FilteredUsers: LgvModel.UserDTO[] = [];
    FilteredUsers$ = new BehaviorSubject(this._FilteredUsers);

    _modeFilteredUsers: LgvModel.UserDTO[] = [];
    modeFilteredUsers$ = new BehaviorSubject(this._modeFilteredUsers);

    _IsLoading: boolean = false;
    IsLoading$ = new BehaviorSubject(this._IsLoading);
    onDestroy$ = new Subject();

    get userInputField(): AbstractControl { return this.UserSearchForm.get('userInput'); }

    constructor(
        private FB: UntypedFormBuilder,
        public UsersSvc: LgvUserService,
    ) { }

    ngOnInit() {
        this.UserSearchForm = this.FB.group({
            userInput: null
        });

        if (this.IsRequired) {
            this.userInputField.addValidators(Validators.required);
        }

        if (this.FilterMode && this.FilterMode === 'Assistant' && this.UserId) {
            this.UsersSvc.FetchAssistantsBinding(this.UserId).pipe(takeUntil(this.onDestroy$)).subscribe(x => {
                let tmpUsers = [];
                for (let assistant of x) {
                    tmpUsers.push(LgvUserService.ConvertObjToUserDTO(assistant));
                }
                this.modeFilteredUsers$.next(tmpUsers);
            });
        } else {
            if (!!this.FilterMode) {
                this.UsersSvc.CachedUsersByRole(this.FilterMode).pipe(filter(f=> f!== null),take(1)).subscribe(x => {
                    this.modeFilteredUsers$.next(x);
                });
            }
        }


        this.UserSearchForm
            .get('userInput')
            .valueChanges
            .pipe(
                tap(() => {
                    // if user has selection and then changes, clear the selection
                    if (this.SelectedUser) {
                        this.OnClearSelection();
                    }
                }),
                tap(() => this.IsLoading$.next(true)),
                switchMap(txtSearch => this.doSearch(txtSearch)
                ),
                delay(300),
                tap(() => {
                    this.IsLoading$.next(false);
                }),
                takeUntil(this.onDestroy$)
            )
            .subscribe(x => {
                this.FilteredUsers$.next(x);
            });


        // when control is shown / hidden from an ngIf, try to preserve it's state...
        if (this.PreSelectedUser) {
            setTimeout(() => {
                this.userInputField.setValue(this.PreSelectedUser);
                this.OnUserSelected(this.PreSelectedUser);
            }, 250);
        }
    }

    doSearch(txtSearch: string): Observable<LgvModel.UserDTO[]>{
        if (this.FilterMode && this.modeFilteredUsers$.value && this.modeFilteredUsers$.value.length > 0) {
            return this.modeFilteredUsers$.pipe(
                map(arr => {
                    return arr.filter(x => x.firstName.toLowerCase().indexOf(txtSearch) !== -1 || x.lastName.toLowerCase().indexOf(txtSearch) !== -1)
                })
            );
        } else {
            return this.UsersSvc.SearchCachedUsers(txtSearch).pipe(
                map(arr => {
                        return arr
                })
            )
        }
        
    }

    ngOnChanges() {
        if (this.SearchState === 'Reset') {
            this.OnClearSelection();
        }
    }

    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }

    displayUser(agent: LgvModel.UserDTO) {
        if (agent) { return `${agent.firstName} ${agent.lastName}`; }
    }

    OnUserSelected(user: LgvModel.UserDTO) {
        this.SelectedUser = user;
        this.OnUserSelectionMade.emit(this.SelectedUser);
        this.ShowSearch = false;
    }

    OnSelectedUserClicked() {
        this.ShowSearch = !this.ShowSearch;
    }

    OnClearSelection() {
        this.SelectedUser = null;
        this.ShowSearch = true;
        this.UserSearchForm.reset();
        this.OnUserSelectionMade.emit(null);
    }
}
